import { render, staticRenderFns } from "./SearchKeyhole.vue?vue&type=template&id=5bb165b6&scoped=true&"
import script from "./SearchKeyhole.vue?vue&type=script&lang=js&"
export * from "./SearchKeyhole.vue?vue&type=script&lang=js&"
import style0 from "./SearchKeyhole.vue?vue&type=style&index=0&id=5bb165b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb165b6",
  null
  
)

export default component.exports